import { http } from 'http';

export default {
  send: transactionId => http.post('/actas/devolucion/sendsms', { transactionId }),

  login: ({ vehicleId, vin, concessionId }) =>
    http.post(`actas/devolucion/${vehicleId}/${vin}/${concessionId}`),

  loginWithGuid: params => http.post('/actas/devolucion/validate/driver', params),

  sendSign: (transactionId, partnerId) =>
    http.post('/actas/devolucion/sign', { transactionId, partnerId }),

  cancelAct: (transactionId, comment) =>
    http.post('/actas/devolucion/cancel', { transactionId, comment }),

  validateDocument: data => http.post('/edoc/validate', data),

  endSign: transactionId => http.post(`/actas/devolucion/${transactionId}/end`),

  // No se está usando
  sendEmail: transactionId => http.post(`/webh/actas/${transactionId}/sendEmail`),

  getDocuments: fileNames => http.post('/edoc/documents', { fileNames })
};
